import { render, staticRenderFns } from "./ClientDash.vue?vue&type=template&id=df6593dc&"
import script from "./ClientDash.vue?vue&type=script&lang=js&"
export * from "./ClientDash.vue?vue&type=script&lang=js&"
import style0 from "./ClientDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports